<template>
  <!-- variableManage -->
  <div class="variableManage">
    <div class="con">
      <div class="left-tree">
        <div class="search" style="margin-bottom:10px">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        </div>
        <div class="mytree" :style="{'height':heights+'px'}">
          <el-scrollbar style="height:calc(100% - 10px);width: 100%;">
            <el-tree :data="channelAndDeviceTree" :expand-on-click-node="true" :props="defaultProps"
              :highlight-current='true' ref="tree" @node-click="checkItem">
              <span class="custom-tree-node" slot-scope="{node, data}">
                <img src="../../../public/static/image/elTree/2.0.png" v-show="data.entityName=='Channel'" />
                <img src="../../../public/static/image/elTree/2.0.png" v-show="!data.entityName" />
                <img src="../../../public/static/image/elTree/2.1.png" v-show="data.entityName=='Device'" />
                <span style="padding:0px  5px;">{{ node.label }}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div class="right-table">
        <div class="mytable">
          <el-table id="demo" ref="table" :max-height="heights" border stripe :data="tableData" style="width: 100%"
            @cell-click="editfn">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="序号" width="60" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="formItemAddr" label="点号" width="80" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.editable">
                  <el-input v-model="scope.row.formItemAddr" size="mini" @blur="saveCell(scope.row)" />
                </div>
                <div v-else @dblclick="enableEdit(scope.row)">
                  {{ scope.row.formItemAddr }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="变量名称" min-width="230">
              <template slot-scope="scope">
                <div v-if="scope.row.editabletow">
                  <el-input v-model="scope.row.name" size="mini" @blur="saveCelltow(scope.row)" />
                </div>
                <div v-else @dblclick="enableEdittow(scope.row)">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="fromName" label="变量全名" min-width="230"> </el-table-column>
            <el-table-column label="数据类型" width="200" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.editablethree" class="myinputsel">
                  <el-select v-model="scope.row.dataType" placeholder="请选择">
                    <el-option v-for="item in dataTypeList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div v-else @dblclick="enableEditthree(scope.row)">
                  {{scope.row.dataType | date_format}}
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" width="180" align="center" fixed="right">
              <template #default="{row}">
                <div class="public-flex" @click="editfn(row)">
                  编辑
                </div>
              </template>
            </el-table-column> -->


          </el-table>
        </div>
      </div>
      <el-drawer title="" :visible.sync="drawer" :with-header="false" :size="drawerSize">
        <div class="drawer-con">
          <div class="Files-top">
            <div class="ic-left"><span>变量配置({{nowEditRow.variableName}})</span></div>
            <div class="btns"></div>
          </div>
          <div class="mydraweritem">
            <span class="item-name">短信通知：</span><el-checkbox v-model="nowEditRow.isSms" :true-label="1"
              :false-label="0"></el-checkbox>
          </div>
          <div class="mydraweritem">
            <span class="item-name">应用类型组：</span><el-select v-model="typeGroup" placeholder="请选择">
              <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="mydraweritem">
            <span class="item-name">应用类型：</span><el-select v-model="nowEditRow.appType" placeholder="请选择">
              <el-option v-for="item in typeValueList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="mydraweritem">
            <span class="item-name">越限类型：</span><el-select v-model="nowEditRow.overLimit" placeholder="请选择"
              @change="overLimitFn">
              <el-option v-for="item in limitList" :key="item.no" :label="item.name" :value="item.no">
              </el-option>
            </el-select>
          </div>
          <div class="mydraweritem" v-if="nowEditRow.limitValues">
            <span class="item-name">越限值列表：</span>
            <!-- nowEditRow.limitValues -->
            <div class="list">
              <span v-for="(e,i) in nowEditRow.limitValues">
                <span>{{e.limitName}}:</span>
                <el-input v-model="e.limitValue" size="mini" style="width: 90px;margin-left: 5px;" />
                <el-input v-model="e.alias" size="mini" style="width: 150px;margin:0 5px;" />
                <span>越限等级:</span>
                <el-select v-model="e.limitLevel" placeholder="请选择" size="mini" style="width: 80px;margin-left: 5px;">
                  <el-option label="一般" :value="0" />
                  <el-option label="紧急" :value="1" />
                  <el-option label="严重" :value="2" />
                </el-select>
              </span>
            </div>
          </div>
          <div class="mydraweritem">
            <span class="item-name">报警类型：</span><el-select v-model="nowEditRow.eventType" placeholder="请选择">
              <el-option v-for="item in policeList" :key="item.no" :label="item.name" :value="item.typeName">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="demo-drawer__footer" style="padding: 20px;">
          <el-button @click="drawer = false;">取 消</el-button>
          <el-button type="primary" @click="finish">确 认</el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
  import {getVariableList,newgetVariableList,updateAddrOrDataType,findAppTypeAndLimit} from "../../api/capacity";
  import {getAllTypeByGroup,getAppTypeByGroupId} from "../../api/energySubType";
  import request from "@/api/http.js";
  export default {
    data () {
      return {
        deviceNo: '',
        heights: Math.round((document.getElementById('app').clientHeight)*0.82),
        channelAndDeviceTree: [],
        defaultProps: {
          children: 'next',
          label: 'name'
        },
        filterText: "",
        loading: false,
        tableData: [],
        drawerSize: "700px",
        drawer: false,
        checked: false,
        dataTypeList: [
          {
            value: 0,
            label: "SByte",
          },
          {
            value: 1,
            label: "Int16",
          },
          {
            value: 2,
            label: "Int32",
          },
          {
            value: 3,
            label: "Byte",
          },
          {
            value: 4,
            label: "UInt16",
          },
          {
            value: 5,
            label: "Uint32",
          },
          {
            value: 6,
            label: "Single",
          },
          {
            value: 7,
            label: "Boolean",
          },
        ],
        editRow: {},
        typeGroup: "",//应用类型组
        groupList: [],//应用类型组
        typeValue: "",//应用类型
        typeValueList: [],//应用类型
        limitList: [],//越限类型
        limitVal: "",//越限类型
        policeList: "",//报警类型
        policeVal: "",//报警类型

        nowEditRow: {}

      };
    },

    mounted () {
      //应用类型组
      getAllTypeByGroup().then(res => {
        this.groupList=res.data;
      })

      request({url: "/eventType/findAll",method: "get"}).then(res => {
        if(res.code==200) {
          this.policeList=res.data;
        }

      })
      this.getChannelAndDeviceTree()
    },
    watch: {
      'typeGroup': function(val) {
        if(val==''||!val) {
          this.typeOptions=[]
          return
        }
        getAppTypeByGroupId({'groupId': val}).then(res => {
          console.log(res,111111);
          if(res.code==200) {
            this.typeValueList=res.data
          }
        })
      },
    },

    methods: {
      overLimitFn (v) {
        findAppTypeAndLimit({'variableName': this.nowEditRow.variableName,groupNo: v}).then(res => {
          if(res.code==200) {
            this.nowEditRow=res.data;
            this.nowEditRow.overLimit=v;
            if(this.nowEditRow.overLimit==-1) {
              this.nowEditRow.overLimit='无'
            }
          }
        })
      },
      finish () {
        console.log(JSON.stringify(this.nowEditRow));
        var data=this.nowEditRow;
        data.deviceNo=this.deviceNo;
        request({url: "/variable/updateAppTypeAndLimit",method: "post",data}).then(res => {
          console.log(res);
          if(res.code==200) {
            this.$message({
              type: 'success',
              message: '修改成功成功!'
            });
          }
        })
      },
      //点号双击
      enableEdit (row) {
        row.editable=true;
        this.$nextTick(() => {
          this.$refs.table.setCurrentRow(row);
          this.$refs.table.$el.querySelector('.el-input input').focus();
        });
      },
      //点号失去焦点
      saveCell (row) {
        row.editable=false;
        this.editRow=row
        //    this.eidt_fn()

      },
      //变量名双击
      enableEdittow (row) {
        row.editabletow=true;
        this.$nextTick(() => {
          this.$refs.table.setCurrentRow(row);
          this.$refs.table.$el.querySelector('.el-input input').focus();
        });
      },
      //变量名失去焦点
      saveCelltow (row) {
        row.editabletow=false;
        this.editRow=row
        //  this.eidt_fn()
      },
      //双击数据类型
      //变量名双击
      enableEditthree (row) {
        row.editablethree=true;
      },
      //确定修改点号变量名数据类型
      eidt_fn () {
        var arrs=this.editRow.fromName.split(".")
        var d={
          dataType: this.editRow.dataType,
          fromItemAddr: this.editRow.formItemAddr,
          newName: arrs[0]+'.'+this.editRow.name,
          oldName: this.editRow.fromName
        }
        console.log("参数",d);
        updateAddrOrDataType(d).then(res => {
          console.log("修改",res);
        })
      },
      getChannelAndDeviceTree () {
        this.$api.deviceApi.getChannelAndDeviceTree(respon => {
          this.channelAndDeviceTree=[respon]
          // console.log("树形结构",this.channelAndDeviceTree);
        },err => {
          this.$dialogMethod.showMessage(err)
        })
      },

      checkItem (val) {
        console.log("设备",val);
        this.deviceNo=val.no;
        this.tableData=[]
        this.getList()
      },
      getList () {
        newgetVariableList({'deviceNo': this.deviceNo}).then(res => {
          console.log("数据",res);
          if(res.code==200) {
            res.data.forEach(item => {
              item.editable=false
              item.editabletow=false
              item.editablethree=false
            })
            this.tableData=res.data
          }
        })
      },
      editfn (row) {
        console.log("编辑",row);
        this.drawer=true;
        findAppTypeAndLimit({'variableName': row.fromName}).then(res => {
          console.log("编辑状态",res);
          if(res.code==200) {
            this.nowEditRow=res.data;
            if(this.nowEditRow.overLimit==-1) {
              this.nowEditRow.overLimit='无'
            }
            request({url: "/limit/findAllGroup",method: "get"}).then(res => {
              if(res.code==200) {
                this.limitList=res.data;
              }
            })
          }
        })
      },


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        var arr=['SByte','Int16','Int32','Byte','UInt16','Uint32','Single','Boolean','String','Byte[]','Double','Decimal','Int64','UInt64','SByte']

        return arr[value]
      },
    }
  };
</script>

<style lang="scss" scoped>
  .list {
    display: flex;
    flex-direction: column;
  }

  .con {
    width: 100%;
    height: 100%;
    display: flex;

    .drawer-con {
      padding: 12px 20px 20px 20px;
    }

    .duanxin {
      margin-top: 30px;
    }

    /deep/.myinputsel .el-input__inner {
      height: 24px;
      line-height: 24px;
    }

    /deep/.myinputsel .el-input__suffix {
      display: flex;
      align-content: center;
    }

    /deep/.myinputsel .el-input__icon {
      line-height: 24px;
    }

    .mydraweritem {
      display: flex;
      margin-top: 20px;
      align-items: center;

      .item-name {
        width: 90px;
        display: flex;
        justify-content: flex-end;
      }
    }

    /deep/.right-table .el-input--mini .el-input__inner {
      height: 24px;
      line-height: 24px;
    }

    .left-tree {
      width: 300px;
      height: 100%;
      background-color: #fff;
      padding: 12px;
      box-sizing: border-box;

      /deep/.el-tree {
        margin-top: -5px;
      }
    }

    .right-table {
      width: calc(100% - 308px);
      height: 100%;
      background-color: #fff;
      padding: 12px 20px;
      box-sizing: border-box;
      margin-left: 8px;
    }
  }
</style>